class PackSelector {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.radios = Array.from(root.querySelectorAll('.pack-option__input'));

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handleChange(radio));
    });

    const checked = this.radios.find((radio) => radio.checked);
    if (checked) this.applyQuantity(checked);
  }

  getQuantityComponent() {
    const scope = this.sectionId ? document.getElementById('ProductInformation-' + this.sectionId) : document;
    return scope ? scope.querySelector('quantity-selector-component') : null;
  }

  handleChange(radio) {
    if (!radio.checked) return;

    this.applyQuantity(radio);

    this.radios.forEach((input) => {
      const card = input.closest('.pack-option');
      if (card) card.classList.toggle('pack-option--selected', input === radio);
    });
  }

  applyQuantity(radio) {
    const quantity = radio.dataset.quantity || '1';
    const component = this.getQuantityComponent();
    if (!component) return;

    if (typeof component.setValue === 'function') {
      component.setValue(quantity);
    }
    if (typeof component.onQuantityChange === 'function') {
      component.onQuantityChange();
    }
    if (typeof component.updateButtonStates === 'function') {
      component.updateButtonStates();
    }
  }
}

function initPackSelectors() {
  document.querySelectorAll('.pack-selector[data-pack-selector]').forEach((root) => {
    if (root.dataset.packSelectorInitialized) return;
    root.dataset.packSelectorInitialized = 'true';
    new PackSelector(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPackSelectors);
} else {
  initPackSelectors();
}

document.addEventListener('shopify:section:load', initPackSelectors);
